import React, { useEffect } from 'react'

//images.
import videos from '../../../images/Video_Camera_Icon.svg.png';
import challengeAnnouncements from '../../../images/challengesComingSoon.avif';
import activeChallenges from '../../../images/activeChallenges.jpg';
import challengeResults from '../../../images/challengeResults.jpg'

//Dependencies.
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { store } from '../../../app/store';
import { allusersslicereducer } from '../../../slices/allUsersSlice';
import { Alert } from 'reactstrap';
import { useSelector } from 'react-redux';

import './Home.styles.css';


const Home = () => {
  const { isLoading, message } = useSelector(allusersslicereducer);
  const navigate = useNavigate();
  const homePageOverlayVariants = {
    initial: {
      y: 550
    },
    animate: {
      y: 0,
      transition: {
        delay: 0.75,
        duration: 1.75,
      }
    }
  }

  useEffect(() => {
    console.log({ storeState: store.getState() });

    return () => {
    }
  }, []);

  try {
    return (
      <div className='home-page-container'>
        {
          isLoading && <Alert color='danger'><h1>{ message }</h1></Alert>
        }
        <motion.div className='home-page-overlay' variants={ homePageOverlayVariants } initial="initial" animate="animate">
          <div className='home-page-overlay-navigationContainer'>
            <motion.div whileHover={{cursor: 'pointer', border: '5.3px solid crimson'}} onClick={() => navigate('/videos/all')}>
              <motion.h1 className='overlay-title' style={{color: 'whitesmoke'}}>ALL VIDEOS.</motion.h1>
              <motion.img src={videos} alt='video camera image' className='img-fluid' />
            </motion.div>
            
            <motion.div whileHover={{cursor: 'pointer', border: '5.3px solid crimson'}} onClick={() => navigate('/challenges/announcements/all')}>
              <motion.img src={challengeAnnouncements} alt='challenges coming soon' className='img-fluid' />
            </motion.div>
            
            <motion.div whileHover={{cursor: 'pointer', border: '5.3px solid crimson'}} onClick={() => navigate('/challenges/actives/all')}>
              <motion.img src={activeChallenges} alt='active challenges' className='img-fluid' />
              <h1 className='overlay-title' style={{color: 'whitesmoke', textAlign: 'center'}}>ACTIVE CHALLENGES.</h1>
            </motion.div>
            
            <motion.div whileHover={{cursor: 'pointer', border: '5.3px solid crimson'}} onClick={() => navigate('/challenges/completed')}>
              <motion.img src={challengeResults} alt='challenge results shown.' className='img-fluid' />
                <h1 className='overlay-title' style={{color: 'whitesmoke', textAlign: 'center'}}>CHALLENGE RESULTS.</h1>
              </motion.div>
          </div>
        </motion.div>
      </div>
    )
  } catch (error) {
    console.error({ error, errorCode: error.code, errorMessage: error.message });
  }
}

export default Home;